module.exports = __webpack_public_path__ + "img/0-6.4f0d021d.gif";